module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4BAMAAABaqCYtAAAAAXNSR0IArs4c6QAAACRQTFRFAAAAfYKCfoGBgICDfn6BgICCfn6Bfn6BfX6Bfn+AfX6BfX6AoJB2RQAAAAt0Uk5TADlBTFdibXn6/f4lulyEAAAAXklEQVQ4y2NgGBCwGwegVHIDNsu4RyWxS8JDjmRJqjuoHI8k2+4E3JJRu5filGSZvXunAy5JC6DvmnFJCikpKSniCgS8kniNxesgvF7BHwh4g2/EpKFhIUmbgpHuAABUefHb5za/wAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/assets/images/elevatorNavigation-icon.png
// module id = WaIh
// module chunks = 241